require('./hireSolidarityCardView.scss');

// @vendor
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// @components
import { CallMeBack } from 'components/callMeBack/callMeBack';
// @common-components
import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKLink } from 'commonsComponents/OKLink';
import { OKWizard } from 'components/OKWizard/OKWizard.jsx';
import { OKSummaryHireCardC } from 'components/OKWizard/OKWizardSummary/OKWizardSummary.jsx';
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @actions
import preContractualMailActions from 'actions/contactCenter/preContractualMailInfo/preContractualMailInfo';
import hireCardImageSelectorActions from 'actions/hireCardImageSelector';
import hireCardNameSelectorActions from 'actions/hireCardNameSelector';
import { resetData } from 'actions/okWizard';
import precontractualDocumentMailAction from 'actions/precontractualDocumentsMailer';
import profileActions from 'actions/profile';

// @utils
import apiURLBuilder from 'core/apiURLBuilder';
import { i18n } from 'core/i18n';
import PersonalDataHelper from 'utilities/personalDataHelper';
// @api
import { APIPost } from 'utilities/APIRequestHelper';
// @steps
import { analyticsId, catalogue } from './analytics/hireSolidarityCardAnalytics.js';
import { HireConfirmationC } from './steps/hireConfirmation.jsx';
import { HireInformation } from './steps/hireInformation.jsx';
import { HireSelectAccount } from './steps/hireSelectAccount.jsx';
import { HireSelectCardImage } from './steps/hireSelectCardImage.jsx';
import { HireSolidarityShippingAdress } from './steps/hireSolidarityShippingAdress.js';


const WebappRender = require('components/conditionalRender/webappRender')
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const WizardError = require('components/commons/wizardError/wizardError');

const shippingAddressAction = require('actions/shippingAddress');
const hireContactDataActions = require('actions/hireContactData');
const mergePreContractualsPDF  = require('actions/mergePreContractualsPDF');
const preContractualInfo = require('actions/preContractualInfo');
const blockedAccountsActions = require('actions/blockedAccounts');
const termsAndCondsInfoActions = require('actions/termsAndCondsInfo');

const { formatText, FormattedText } = i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { getShippingAddressDetails, getDebitCardHiringStatus } = require('utilities/hireCardsHelper');
const {
    recordPath,
    PROC_END,
    PROC_CONTRACTS
} = require('utilities/tagging');
const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { SOLIDARIA_CARD_PRODUCT_ALIAS,
        PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');

// @constants
const { API_CHANNEL, SOLIDARITY_CARD_TYPE, SOLIDARITY_CARD, SOLIDARITY_CARD_SUBTYPE, SOLIDARITY_CARD_STANDARD } = require('constants/index');
const { HIRE_CARD_SOLIDARITY_DEBIT } = require('constants/operationCodesAccounts');
const insuranceURL = "https://bancoonline.openbank.es/csopen/Satellite?c=DocumentoGS&canal=CWebComOB&cid=1431484373971&empr=BrokerOpenBank&leng=es_ES&pagename=BrokerOpenBank/DocumentoGS/DocumentoGSPreview"
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const {
    MESSAGE_HIRE_24H,
    CREDIT_CARD_REVOLVING_PROCESS
} = require('constants/flagBasedFeatures');
const { validRevolvingCardType } = require('utilities/APIParsingHelper');

class HireSolidarityCardView extends Component {

    constructor (props) {
        super(props);
        this.state = {
            consentsError: false,
            errorMsg: '',
            authorization: false,
            disclaimerErrorState: false
        }
        this.handleIsReady = this.handleIsReady.bind(this);
    }
    componentDidMount() {
        const {
            getshippingAddressList,
            getBlockedAccounts,
            immAccountsById,
            resetPrecontractualDocumentMail
        } = this.props;
        resetPrecontractualDocumentMail();
        getshippingAddressList();
        getBlockedAccounts(immAccountsById.toList(),HIRE_CARD_SOLIDARITY_DEBIT);
        if (!__CONTACT_CENTER__) {
            const {requestPDFMerge} = this.props;
            const pdfurls = getCardsPreContractPdfData()['solidaria_card'].preContractPdfLink;
            const product = {
                type: SOLIDARITY_CARD_TYPE,
                subtype: SOLIDARITY_CARD_SUBTYPE,
                standard: SOLIDARITY_CARD_STANDARD
            };
            requestPDFMerge(pdfurls, [product]);
        }
    }

    componentWillUnmount () {
        const {
            localResetCardImage,
            localResetCardName,
            localResetData,
            localResetHireContactData,
            resetPreContractualInfo,
            resetBlockedAccounts,
            resetPrecontractualMail,
            resetTermsAndCondsText,
        } = this.props;

        localResetHireContactData();
        localResetData();
        localResetCardImage();
        localResetCardName();
        resetPreContractualInfo();
        resetBlockedAccounts();
        resetTermsAndCondsText();

        if(__CONTACT_CENTER__) resetPrecontractualMail()
    }

    getProcessDetail() {
        return `${SOLIDARITY_CARD_TYPE}.${SOLIDARITY_CARD_SUBTYPE}`;
    }

    handleConfirmLeave () {
        this.props.history.push('/myprofile/cards');
    }

    handleOnChange = () => {
        this.setState(state => ({
            ...state,
            authorization: !state.authorization,
            disclaimerErrorState: false
        }));
    }
 setHireMessage =(validateLoading, setSteps, localRestrictionWizardError)=>{
    // Hire Restriction 24H
     const {
        visibleStep,
        hireRestrictionFF,
        immCards
    } = this.props;
    if (visibleStep === 0 && hireRestrictionFF) {
    const immCardById = immCards && immCards.get('byId');
    const immCardByOrder = immCards && immCards.get('byOrder');
    const cardObj =
      immCardByOrder &&
      immCardByOrder.map(cardId => {
        const immCard = immCardById && immCardById.get(cardId);
        return {
          contractNumber: immCard.getIn(['contract', 'number']),
          pan: immCard.get('number'),
          product: immCard.get('newProduct'),
          subType: immCard.get('productSubType'),
          standard: immCard.getIn(['product', 'standard']),
        };
      });
    validateLoading(true);
    return APIPost(
      () => {},
      apiURLBuilder.getURL('validateCardHire'),
      {
        query: { cards: cardObj },
      },
    )
      .then(() => {
        validateLoading(false);
        localRestrictionWizardError(false,false);
        setSteps(visibleStep);
        })
      .catch(error => {
        if (error) {
          if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
            validateLoading(false);
            localRestrictionWizardError(true,false);
          }
          else {
            validateLoading(false);
            localRestrictionWizardError(false,true);
          }
        }
      });

}

}
    submitResults = (localSetWizardSuccess, localSetWizardError, dataToken, getState) => {
        const baseURL = apiURLBuilder.getURL('solidarity');
        const {
            immAccountsById,
            accountId,
            minAmount,
            maxAmount,
            imageSelected,
            charityFoundations,
            setTermsAndCondsInfo,
        } = this.props;
        const cardDesignKey = `0000${imageSelected.split('.')[3]}`;
        const immShippingAddress = getState().shippingAddress;
        const shippingAddressType = immShippingAddress.get('shippingAddressType');
        const immHireCardNameSelector = getState().hireCardNameSelector;
        const selectedName = immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')]);
        let addressDetails = null;
        let numDomicilio  = null;

        if(shippingAddressType === NEW_SHIPPING_ADDRESS) {
            const immContactData = getState().hireContactData;
            addressDetails = getShippingAddressDetails(immContactData);
        } else {
            numDomicilio = immShippingAddress.getIn(['shippingAddress','numDomicilio']);
        }

        const requestData = {
            header: {
                version: 2
            },
            query: {
                addressDetails: addressDetails,
                deliverToProvidedDetails: true,
                cardDetails:{
                    cuentaCargo: immAccountsById.getIn([accountId, 'oldFullContractNumber']),
                    nombreAdicional: "",
                    nombreBeneficiario: selectedName,
                    tarjetaRef: {
                        canal: API_CHANNEL,
                        standard: cardDesignKey,
                        subTipo: SOLIDARITY_CARD_SUBTYPE,
                        tipo: SOLIDARITY_CARD_TYPE
                    }
                },
                dataToken,
                numDomicilio,
                minAmount,
                maxAmount,
                ngos: charityFoundations.map(cf => cf.getIn(['suggestion', 'ngoId'])),
            }
        };

        const termsAndsCondsHiringData = [
            {
                standard: cardDesignKey,
                subType: SOLIDARITY_CARD_SUBTYPE,
                type: SOLIDARITY_CARD_TYPE,
            }
        ];

        APIPost(() => {}, `${baseURL}/ngo-cards`, requestData)
            .then(() => {
                localSetWizardSuccess();
                setTermsAndCondsInfo(SOLIDARIA_CARD_PRODUCT_ALIAS, termsAndsCondsHiringData);
            })
            .catch((error) => {
                const status = getDebitCardHiringStatus(error);
                const unknownError = typeof error === 'object' ? JSON.stringify(error) : String(error);
                this.setState({
                    errorMsg: (status && status.errorMsg || unknownError)
                });
                localSetWizardError(status && status.error || unknownError);
            });
    };

    handleIsReady() {
        let isReady = false;

        if (this.props.visibleStep === 0) {
            isReady = true;
        }

        return isReady;
    }

    render () {
        const {
            accountId,
            allAccountsInactive,
            charityFoundations,
            error,
            gestorCrossEnabled,
            imagesById,
            imageSelected,
            immAccountsById,
            immHireCardNameSelector,
            immHireContactData,
            immPrecontractualMail,
            immProfile,
            immShippingAddressList,
            maxAmount,
            minAmount,
            requestProfile,
            /* eslint-disable react/prop-types */
            sendPreContractualMail,
            sendPrecontractualDocumentMail,
            setShippingAddress,
            /* eslint-enable react/prop-types */
            setTermsAndCondsText,
            submitSuccessful,
            originCountry,
            hireRestrictionFlag,
            hireRestrictionFF,
            flagBasedFeatures
        } = this.props;
        const {
            authorization
        } = this.state
        let foundations, account;
        const immAccount = immAccountsById.get(accountId);
        const imgSrc = imagesById.getIn([imageSelected, 'url']);
        const hasEmail = PersonalDataHelper.getEmail(immProfile).length > 0;
        const immShippingAddress = immShippingAddressList.get('shippingAddress');
        const preContractURL = 'https://bancoonline.openbank.es/csopen/Satellite?c=DocumentoGS&canal=CWebComOB&cid=1431480783894&empr=BrokerOpenBank&leng=es_ES&pagename=BrokerOpenBank/DocumentoGS/DocumentoGSPreview';
        let addressContent = PersonalDataHelper.getFormattedAddress(immProfile);

        if (!immShippingAddress.isEmpty()) {
            addressContent = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        }

        if (immAccount) {
            const accountIban = getLastNChars(immAccount.get('iban'));
            account =  (
                <div>
                    <span>{immAccount.get('alias')}</span>
                    &nbsp;
                    <span>{accountIban}</span>
                </div>
            );
        }

        // This is the definition of the button for the wizard last step. We
        // need to set the name, and the url where we are going before finishing
        // all the steps.

        const goBack = {
            label: <FormattedText value="cardBlock-backToCards" />,
            url: '/myprofile/cards',
            action: () => {
                this.props.localResetData();
                this.props.localResetCardImage();
                this.props.localResetCardName();
            }
        };

        const tealium = {
            processDetail: this.getProcessDetail()
        }

        // FRONTCC-31: If the selection of the component is made with ContactCenterRender the renderization fails
        let hireInformation;
        if(!__CONTACT_CENTER__) {
            if(gestorCrossEnabled) {
                hireInformation = (
                    <HiringProductInformation
                        productAlias={SOLIDARIA_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                )
            } else {
                hireInformation = (<HireInformation />)
            }
        } else {
            const {
                authorization,
                disclaimerErrorState
            } = this.state
            const handleOnChange = this.handleOnChange;
            let legalTextAreaLabel = '';
            const showIneAndRevolving = flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            const getPoeKey = (key) => {
                return `revolvingProcessDocuments-revolvingProcessDocuments_${key}`;
            }

            if (showIneAndRevolving) {
                legalTextAreaLabel = `${validRevolvingCardType(SOLIDARITY_CARD_TYPE, SOLIDARITY_CARD_SUBTYPE) ? formatText(getPoeKey('readInneInformation')) : formatText('hireSolidarityCard-readInneInformation')}`
            }

            hireInformation = (
                <HireInformation
                    immProfile={immProfile}
                    immPrecontractualMail={immPrecontractualMail}
                    requestProfile={requestProfile}
                    sendPreContractualMail={sendPreContractualMail}
                    link={preContractURL}
                    insuranceURL={insuranceURL}
                    setTermsAndCondsText={setTermsAndCondsText}
                    authorization={authorization}
                    disclaimerErrorState={disclaimerErrorState}
                    handleOnChange={handleOnChange}
                    legalTextAreaLabel={legalTextAreaLabel}
                    processDetail={this.getProcessDetail()}
                />
            );
        }

        // These are the main contents.
        let wizardContents = (
            <OKWizard
                wizardSideContent={
                    <div className="row">
                        <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation" id="printable-wizard">
                            <OKSummaryHireCardC
                                addressContent={addressContent}
                                hasShippingAddress={true}
                                immAddress={immShippingAddress}
                                immShippingAddressList={immShippingAddressList}
                                selectedAccount={accountId}
                                type={SOLIDARITY_CARD}
                                creditType="solidarity-card"
                                ong={charityFoundations}
                                solidarityCardLimits={{
                                    min: minAmount,
                                    max: maxAmount
                                }}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('breadcrumb-cards')} hasEntrance={false}/>
                        </div>
                    </div>
                }
                submitResults={this.submitResults}
                setHireMessage={this.setHireMessage}
                onPreLeaveModalReady={this.handleIsReady}
                onConfirmLeave={() => this.handleConfirmLeave()}
                tealium={tealium}
                authorization={authorization}
                type={SOLIDARITY_CARD}
            >
                {hireInformation}
                <HireSelectAccount originCountry={originCountry} processDetail={this.getProcessDetail()} />
                <HireSelectCardImage
                    cardImageIds={['B.506.011.001', 'B.506.011.002', 'B.506.011.003', 'B.506.011.004']}
                    processDetail={this.getProcessDetail()}
                />
                <HireSolidarityShippingAdress
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                    processDetail={this.getProcessDetail()}
                />
                <HireConfirmationC
                    link={preContractURL}
                    addressContent={addressContent}
                    sendPrecontractualDocumentMail={sendPrecontractualDocumentMail}
                    setTermsAndCondsText={setTermsAndCondsText}
                    processDetail={this.getProcessDetail()}
                />
            </OKWizard>
        );

        // The success steps.

        if (submitSuccessful) {
            const emailUser = PersonalDataHelper.getEmail(immProfile);
            recordPath('tarjeta-solidaria', 'tarjeta-solidaria', PROC_CONTRACTS, PROC_END);

            if (charityFoundations) {
                foundations = charityFoundations.map((foundation, index) => {
                    return(
                        <div key={index.toString()}>
                            {foundation.getIn(['suggestion', 'name'])}
                        </div>
                    )
                });
            }

            wizardContents = (
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <WizardSuccess
                        successMessage={<FormattedText value="hireSolidarityCard-successTitle" />}
                        successSubMessage={<FormattedText value="hireSolidarityCard-successSubTitle" />}
                        mainButton={goBack}
                        tealium={catalogue[analyticsId.SOLIDARITY_CARD_WIZARD_SUCCESS]({ productName: tealium.processDetail })}
                        isSecondVersion
                    >
                        <div className="row hire-solidarity-card-view__info-card">
                            <div className="col-xs-6">
                                <img className="hire-solidarity-card-view__image-card" src={imgSrc} />
                            </div>
                            <div className="col-xs-6">
                                <div>
                                    <div className="hire-solidarity-card-view__summary-title">
                                        <FormattedText value="hireCardSidebar-shippingAddress" />
                                    </div>
                                    <strong>{addressContent}</strong>
                                </div>
                            </div>
                            <div className="col-xs-12 hire-solidarity-card-view__bottom-information">
                                <div className="hire-solidarity-card-view__list-information">
                                    <div className="hire-solidarity-card-view__summary-title">
                                        <FormattedText value="hireSolidarityCard-selectedName" />
                                    </div>
                                    <strong>{immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}</strong>
                                </div>
                                <div className="hire-solidarity-card-view__list-information">
                                    <div className="hire-solidarity-card-view__summary-title">
                                        <FormattedText value="hireCardSidebar-selectedAccount" />
                                    </div>
                                    <strong>{account}</strong>
                                </div>
                                <div className="hire-solidarity-card-view__list-information">
                                    <FormattedText className="hire-solidarity-card-view__summary-title" value="hireCardSidebar-ong" />
                                    <strong>{foundations}</strong>
                                </div>
                                <WebappRender>
                                    {hasEmail &&
                                        <div>
                                            <FormattedText value="hireSolidarityCard-successEmailInformation" injectedStrings={[emailUser]} />
                                            &nbsp;
                                            <OKLink
                                                modifier="emphasize"
                                                target="_blank"
                                                to={preContractURL}
                                            >
                                                <FormattedText value="hireSolidarityCard-successEmailInformation2" />
                                            </OKLink>
                                            &nbsp;
                                            <FormattedText value="hireSolidarityCard-successEmailInformation3" />
                                            &nbsp;
                                            <OKLink
                                                modifier="emphasize"
                                                target="_blank"
                                                to={insuranceURL}
                                            >
                                                <FormattedText value="hireSolidarityCard-successEmailInformation4" />
                                            </OKLink>
                                            {/* &nbsp; */} {/* Don't use spaces in POEditor!!! */}
                                            <FormattedText value="hireSolidarityCard-successEmailInformation5" />
                                        </div>
                                    }
                                    {!hasEmail &&
                                        <div>
                                            <FormattedText value="hireSolidarityCard-noEmailMessage2" injectedStrings={[emailUser]} />
                                            &nbsp;
                                            <OKLink
                                                modifier="emphasize"
                                                target="_blank"
                                                to={preContractURL}
                                            >
                                                <FormattedText value="hireSolidarityCard-noEmailMessage3" />
                                            </OKLink>
                                            &nbsp;
                                            <FormattedText value="hireSolidarityCard-noEmailMessage4" />
                                            &nbsp;
                                            <OKLink
                                                modifier="emphasize"
                                                target="_blank"
                                                to={insuranceURL}
                                            >
                                                <FormattedText value="hireSolidarityCard-noEmailMessage5" />
                                            </OKLink>
                                            {/* &nbsp; */} {/* Don't use spaces in POEditor!!! */}
                                            <FormattedText value="hireSolidarityCard-noEmailMessage6" />
                                            <p>
                                                <FormattedText value="hireSolidarityCard-noEmailMessage" />
                                            </p>
                                        </div>
                                    }
                                </WebappRender>
                            </div>
                        </div>
                    </WizardSuccess>
                </div>
            );
            }
            // The error step.
            else if (error) {
                recordPath('tarjeta-solidaria', 'tarjeta-solidaria', PROC_CONTRACTS);
                const errorSubMessage = <FormattedText value="hireCardRevolving-errorTextGeneric" />
                wizardContents = (
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <WizardError
                            errorMessage={formatText('hireCardOpenDebit-errorTitleGeneric')}
                            errorSubMessage={errorSubMessage}
                            mainButton={goBack}
                            tealium={catalogue[analyticsId.SOLIDARITY_CARD_WIZARD_ERROR]({
                                productName: tealium.processDetail,
                                errorMessage: formatText('hireCardOpenDebit-errorTitleGeneric'),
                            })}
                            isSecondVersion
                        >
                            <FormattedText value="hireCardRevolving-errorTextGeneric" />
                        </WizardError>
                    </div>
                );
            } else if (allAccountsInactive) {
            wizardContents = (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    <InactiveAccountsError
                        navigateToBackButtonText={'cards'}
                        navigateToBackButtonURL={'cards'}
                    />
                </div>
            );
        } else if (!!this.state.errorMsg) {
                const { errorMsg } = this.state;
            const error = errorMsg ? `hireDebitErrors-${errorMsg}` : `hireCardRevolving-errorTextGeneric`
                recordPath('tarjeta-solidaria', 'tarjeta-solidaria', PROC_CONTRACTS);
                wizardContents = (
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <WizardError
                            errorMessage={formatText('hireCardOpenDebit-errorTitleGeneric')}
                            errorSubMessage={formatText(error)}
                            mainButton={goBack}
                            tealium={catalogue[analyticsId.SOLIDARITY_CARD_WIZARD_ERROR]({
                                productName: tealium.processDetail,
                                errorMessage: formatText('hireCardOpenDebit-errorTitleGeneric'),
                            })}
                            isSecondVersion
                        >
                        </WizardError>
                    </div>
            );
        } else if (hireRestrictionFlag && hireRestrictionFF) {
            const errorSubMessage =<FormattedText value="hireCard-errorRestrictionSubtitleAccount" />
            const cancleButton ={
                label: (
                    <FormattedText
                        value="hireCard-errorRestrictionCancleButtonText"
                    />
                ),
                url: '/myprofile/cards'
                };
            wizardContents = (
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <WizardError
                        errorMessage={formatText('hireCard-errorRestrictionTitleAccount')}
                        errorSubMessage={errorSubMessage}
                        mainButton={goBack}
                        tealium={catalogue[analyticsId.SOLIDARITY_CARD_WIZARD_ERROR]({
                            productName: tealium.processDetail,
                            errorMessage: formatText('hireCard-errorRestrictionTitleAccount'),
                        })}
                        isSecondVersion
                        cancleButton={cancleButton}
                    ></WizardError>
                </div>
            );
        }

        return (
            <div className="hire-solidarity-card-view" id="printable-wizard">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={[
                                    {
                                        text: formatText('breadcrumb-cards'),
                                        url: '/myprofile/cards'
                                    },
                                    {
                                        text: formatText('hireSolidarityCard-breadcrumb')
                                    }
                                ]}
                                finalTitle={formatText('hireSolidarityCard-pageTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {wizardContents}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HireSolidarityCardView.propTypes = {
    accountId: PropTypes.string.isRequired,
    allAccountsInactive: PropTypes.bool.isRequired,
    changeId: PropTypes.func,
    charityFoundations: PropTypes.array.isRequired,
    error: PropTypes.bool.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    getBlockedAccounts: PropTypes.func,
    getshippingAddressList: PropTypes.func,
    imageSelected: PropTypes.string,
    imagesById: PropTypes.string,
    history: PropTypes.object.isRequired,
    immAccountsById: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object,
    immPreContractualInfo: PropTypes.object.isRequired,
    immPrecontractualMail: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immShippingAddressList: PropTypes.object,
    localResetCardImage: PropTypes.func.isRequired,
    localResetCardName: PropTypes.func.isRequired,
    localResetData: PropTypes.func.isRequired,
    localResetHireContactData: PropTypes.func.isRequired,
    maxAmount: PropTypes.number.isRequired,
    minAmount: PropTypes.number.isRequired,
    originCountry: PropTypes.string,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func,
    resetPrecontractualDocumentMail: PropTypes.func,
    resetPreContractualInfo: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetTermsAndCondsText: PropTypes.func.isRequired,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsInfo: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    submitSuccessful: PropTypes.bool.isRequired,
    visibleStep: PropTypes.number,
    hireRestrictionFF: PropTypes.bool,
    immCards: PropTypes.object,
    hireRestrictionFlag: PropTypes.bool,
    flagBasedFeatures: PropTypes.bool
};

HireSolidarityCardView.defaultProps = {
    imageSelected: '',
    allAccountsInactive: false
};

module.exports.HireSolidarityCardView = connect(
    state => ({
        accountId: state.okWizard.getIn(['steps', 1, 'accountId']),
        allAccountsInactive: state.okWizard.get('allAccountsInactive'),
        charityFoundations: state.okWizard.getIn(['steps', 1, 'charityFoundations']),
        error: state.okWizard.get('error'),
        flagBasedFeatures: state.flagBasedFeatures,
        gestorCrossEnabled: state.flagBasedFeatures.get('web-gc-enabled'),
        hireRestrictionFF: state.flagBasedFeatures.get(MESSAGE_HIRE_24H),
        immCards: state.cards,
        hireRestrictionFlag: state.okWizard.get('hireRestriction'),
        imageSelected: state.okWizard.getIn(['steps', 2, 'imageSelected']),
        imagesById: state.hireCardImageSelector.get('imagesById'),
        immAccountsById: state.accounts.get('byId'),
        immConsents: state.gdprConsents,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHireContactData: state.hireContactData,
        immPreContractualInfo: state.preContractualInfo,
        immPrecontractualMail: state.preContractualMail,
        immProfile: state.profile,
        immShippingAddressList: state.shippingAddress,
        maxAmount: state.okWizard.getIn(['steps', 1, 'maxAmount']),
        minAmount: state.okWizard.getIn(['steps', 1, 'minAmount']),
        originCountry: state.profile.get('originCountry'),
        submitSuccessful: state.okWizard.get('submitSuccessful'),
        visibleStep: state.okWizard.get('currentStep'),
    }),
    {
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        getshippingAddressList: shippingAddressAction.getShippingAddressList,
        localResetCardImage: hireCardImageSelectorActions.reset,
        localResetCardName: hireCardNameSelectorActions.reset,
        localResetData: resetData,
        localResetHireContactData: hireContactDataActions.reset,
        requestPDFMerge: mergePreContractualsPDF.requestPDFMerge,
        requestProfile: profileActions.requestProfile,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        resetPrecontractualDocumentMail: precontractualDocumentMailAction.resetPrecontractualDocumentMail,
        resetPreContractualInfo: preContractualInfo.resetPreContractualInfo,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetTermsAndCondsText: termsAndCondsInfoActions.reset,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        sendPrecontractualDocumentMail: precontractualDocumentMailAction.sendPrecontractualDocumentMail,
        setShippingAddress: shippingAddressAction.setShippingAddress,
        setTermsAndCondsInfo: termsAndCondsInfoActions.setTermsAndCondsInfo,
        setTermsAndCondsText: termsAndCondsInfoActions.setTermsAndCondsText,
    }
)(withRouter(HireSolidarityCardView));
